const preRouteAuth = '/auth';
const preRouteMain = '';

export const AUTH_ROUTER = {
  LOGIN: `${preRouteAuth}/login`
};

export const MAIN_ROUTER = {
  HOME: `${preRouteMain}/`,

  //User
  PROFILE: `/profile`,
  CHANGE_PASSWORD: `/change-password`,

  // Dashboard
  DASHBOARD_HOME: `${preRouteMain}/dashboard/trang-chu`,
  DASHBOARD_DEVICE: `${preRouteMain}/dashboard/thiet-bi`,
  DASHBOARD_BODY: `${preRouteMain}/dashboard/body`,
  DASHBOARD_VIBRATION: `${preRouteMain}/dashboard/cam-bien-rung`,
  DASHBOARD_LASER: `${preRouteMain}/dashboard/may-laser`,
  DASHBOARD_MAINTENANCE: `${preRouteMain}/dashboard/bao-tri`,
  DASHBOARD_INCIDENT: `${preRouteMain}/dashboard/su-co`,
  DASHBOARD_ERROR_LOG_LIST: `${preRouteMain}/dashboard/log-loi-van-hanh`,
  DASHBOARD_INCIDENT_LIST: `${preRouteMain}/dashboard/tong-quan-loi`,
  DASHBOARD_MATERIAL: `${preRouteMain}/dashboard/vat-tu`,
  DASHBOARD_FEATURE: `${preRouteMain}/dashboard/tinh-nang`,
  DASHBOARD_ANALYTICS: `${preRouteMain}/dashboard/phan-tich`,

  // Cau hinh
  CATEGORY_MACHINE_TYPE: `${preRouteMain}/cau-hinh/loai-may`,
  CATEGORY_PROTOCOL: `${preRouteMain}/cau-hinh/giao-thuc-ket-noi`,
  CATEGORY_UNIT: `${preRouteMain}/cau-hinh/don-vi`,
  CATEGORY_DEVICE: `${preRouteMain}/cau-hinh/thiet-bi`,
  CATEGORY_MAIL_CONFIG: `${preRouteMain}/cau-hinh/mail-config`,

  // He thong
  SYSTEM_USER: `${preRouteMain}/he-thong/nguoi-dung`,
  SYSTEM_ROLE: `${preRouteMain}/he-thong/vai-tro`,

  NOTIFICATION: `${preRouteMain}/thong-bao`,
};
